import { Badge } from "@/components/ui/badge";
import { getTaskPriorityMeta, type TaskPriority } from "@/lib/task-priority";
import { cn } from "@/lib/utils";

interface TaskPriorityBadgeProps {
  priority?: TaskPriority | null;
  className?: string;
}

export function TaskPriorityBadge({ priority = "medium", className }: TaskPriorityBadgeProps) {
  const meta = getTaskPriorityMeta(priority ?? "medium");
  return (
    <Badge variant="outline" className={cn(meta.className, className)}>
      {meta.label}
    </Badge>
  );
}
